import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { useTranslation } from "components/i18n/source";

import Button from "../atoms/Button";
import Text from "../atoms/Text";
import Section from "../layouts/Section";
import Spacer from "../layouts/Spacer";

import styles from "../components/Accounts/Accounts.module.scss";

function ConfirmationCodeStartVerificationFlow({ city, onSubmit }) {
  const { t } = useTranslation();

  return (
    <Section>
      <Text
        translateKey="sonder_one.popups.ConfirmationCodeSignInPopup.headerStartVerificationFlow"
        types={["h4", "medium"]}
        className={classnames(styles.header, styles.centered_text)}
      />
      <Spacer />
      <Text types={["cancel", "subtitles"]}>
        {t(
          "sonder_one.popups.ConfirmationCodeSignInPopup.startVerificationFlowHelp",
          { city: city },
        )}
      </Text>
      <Spacer size="s-4x" />
      <Section type="full-width">
        <Button
          textProps={{
            translateKey: "sonder_one.popups.ConfirmationCodeSignInPopup.next",
            types: ["subtitles"],
          }}
          onClick={onSubmit}
          upperCase={false}
        />
      </Section>
      <Spacer size="s-4x" />
    </Section>
  );
}

ConfirmationCodeStartVerificationFlow.propTypes = {
  city: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

ConfirmationCodeStartVerificationFlow.defaultProps = {};

export default ConfirmationCodeStartVerificationFlow;
